import { FormControl } from '@thoughtspot/radiant-react/widgets/form-control';
import { Input } from '@thoughtspot/radiant-react/widgets/input';
import _ from 'lodash';
import React from 'react';
import styles from '../../styles/form-builder.module.scss';
import { validateInputField } from '../../utils/form-builder.util';
export const NumberInputFormComponent = ({ label, elementKey, defaultValue, onChange, value, inputValidation, isDisabled = false, }) => {
    const onInputChange = (value) => {
        onChange(elementKey, value);
    };
    const errorMessage = React.useMemo(() => validateInputField(value, inputValidation), [value]);
    return (React.createElement(FormControl, { label: label, className: styles.formComponentItem, errorMessage: errorMessage, hasError: !_.isEmpty(errorMessage), disabled: isDisabled, "data-testid": `test-id-${elementKey}` },
        React.createElement(Input.Number, { value: value ?? defaultValue, ariaLabel: label, key: elementKey, onChange: onInputChange, disabled: isDisabled })));
};
//# sourceMappingURL=number-input-form.component.js.map